import React from 'react';

const CONTACT_EMAIL = 'samedakgul99@gmail.com';

// Google Play requires a web page where users can request account deletion
// without reinstalling the app.
const DeleteAccountSonora = () => {
    return (
        <div className="min-h-screen bg-dark pt-24 pb-16">
            <div className="max-w-screen-md mx-auto px-6 text-lg font-custom2 text-gray-300 space-y-6">
                <h1 className="text-3xl font-custom1 text-white">Delete your Sonora AI account</h1>

                <section className="space-y-3">
                    <h2 className="text-2xl font-custom1 text-white">In the app</h2>
                    <ol className="list-decimal ml-6 space-y-1">
                        <li>Open Sonora AI and go to the <strong className="text-white">Profile</strong> tab.</li>
                        <li>Tap <strong className="text-white">Delete Account</strong> and confirm.</li>
                    </ol>
                </section>

                <section className="space-y-3">
                    <h2 className="text-2xl font-custom1 text-white">By email</h2>
                    <p>
                        Send an email to <a href={`mailto:${CONTACT_EMAIL}?subject=Sonora%20AI%20account%20deletion`} className="text-accent-orange hover:underline">{CONTACT_EMAIL}</a> with the subject "Sonora AI account deletion". Include your username shown on the Profile tab so we can find your account. We complete requests within 30 days and confirm by email.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-2xl font-custom1 text-white">What is deleted</h2>
                    <p>Your account, songs, lyrics, generation history, voice profiles and review reward records are deleted, and your songs are removed from Discover. Purchase and transaction records may be kept where required for accounting, tax or legal reasons. Active subscriptions are managed by Google Play: cancel them in the Play Store, because deleting your account does not cancel a subscription.</p>
                </section>

                <p>See our <a href="/sonora-ai/privacy-policy" className="text-accent-orange hover:underline">Privacy Policy</a> for details.</p>
            </div>
        </div>
    );
};

export default DeleteAccountSonora;
